<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  span {
    @include mixins.body3-tooltip-and-caption();
  }
</style>

<script>
  import Dropdown from "../Dropdown/Dropdown.svelte";
  import ListItem from "../Dropdown/ListItem.svelte";

  let { value = $bindable(10) } = $props();
  let close = $state(null);
</script>

<Dropdown kind="ghost-blue" size="xs" bind:close>
  <span slot="button">{value} per page</span>
  {#each [10, 25, 50, 100] as length}
    <ListItem
      selected={value === length}
      onclick={() => {
        value = length;
        if (close) close();
      }}>{length}</ListItem
    >
  {/each}
</Dropdown>
